import { render } from "./SetupScheduleServiceButton.vue?vue&type=template&id=0e06fe05"
import script from "./SetupScheduleServiceButton.vue?vue&type=script&lang=js"
export * from "./SetupScheduleServiceButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__